import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

import './EventGridItem.scss';

import { IEvent } from '../../utils/models';
export interface IEventGridItemProps {
  event: IEvent;
}

const EventGridItem = ({
  event: { title, image, availability, payPerView },
}: IEventGridItemProps) => {
  const { date, time } = availability || {};
  return (
    <article className="event-grid-item">
      {payPerView && <span className="event-grid-item__live-banner">LIVE</span>}
      <div className="event-grid-item__image-container">
        {image?.imageFile.childImageSharp ? (
          <GatsbyImage
            image={image?.imageFile.childImageSharp.gatsbyImageData}
            className="event-grid-item__image"
            alt={title}
          />
        ) : (
          <img
            className="event-grid-item__image"
            src={image?.url}
            alt={title}
          />
        )}
      </div>
      <div className="event-grid-item__content">
        <h3 className="event-grid-item__title">{title}</h3>
        {date ? (
          <p className="event-grid-item__availability">
            Available {date} {time && `, `} {time}
          </p>
        ) : null}
      </div>
    </article>
  );
};

export default EventGridItem;
